import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  quotes: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  quotes: state => state.quotes,

  getById: (state) => (id) => {
    return state.quotes.find(quote => quote.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of clients.
   */
  getQuotes ({ commit }, id, payload) {
    return http.get(`/quotes/list?client_id=${id}`).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the quotes state.
  */
  [SET_LIST] (state, quotes) {
    state.quotes = quotes
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
